import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

const VITE_DOCUMENT_PATH =
	import.meta.env.VITE_DOCUMENT_PATH ||
	"https://mill-cmms.roanokesteel.com/vaultix/";

export const DrawingsDownloadButtons = ({ data }: Props) => {
	if (data.id !== -1) {
		const buttonBaseStyle = {
			textDecoration: "none",
			fontWeight: 500,
			fontSize: "11px",
			borderRadius: "3px",
			minWidth: "60px",
			height: "32px",
			whiteSpace: "nowrap" as const,
		};

		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 size={{ xs: 4 }}>
					<Button
						href={`${VITE_DOCUMENT_PATH}${data?.PDFPath}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						style={{
							...buttonBaseStyle,
							...(data?.PDFPath && {
								border: "1px solid #CC2643",
								color: "#CC2643",
							}),
						}}
						disabled={data?.PDFPath === null}
						download={`${data?.DocumentName} ${data?.PDFPath}`}
					>
						PDF
					</Button>
				</Grid2>
				<Grid2 size={{ xs: 4 }}>
					<Button
						href={`${VITE_DOCUMENT_PATH}${data?.DocPath}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						style={{
							...buttonBaseStyle,
							...(data?.DocPath && {
								border: "1px solid #1976d2",
								color: "#1976d2",
							}),
						}}
						disabled={data?.DocPath === null}
						download={`${data?.DocumentName} ${data?.DocPath}`}
					>
						ORIGINAL
					</Button>
				</Grid2>
				<Grid2 size={{ xs: 4 }}>
					<Button
						href={`${VITE_DOCUMENT_PATH}${data?.PNGPath}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						style={{
							...buttonBaseStyle,
							...(data?.PNGPath && {
								border: "1px solid #357a38",
								color: "#357a38",
							}),
						}}
						disabled={data?.PNGPath === null}
						download={`${data?.DocumentName} ${data?.PNGPath}`}
					>
						PNG
					</Button>
				</Grid2>
			</Grid2>
		);
	}
	return null;
};
